/**
 * @generated SignedSource<<4ee6fef6627b0e3efc035124a5c7204c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

const node = function () {
  var v0 = [{
      "kind": "Literal",
      "name": "filter",
      "value": {
        "entityId": "acquisition"
      }
    }],
    v1 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "json",
      "storageKey": null
    };
  return {
    "fragment": {
      "argumentDefinitions": [],
      "kind": "Fragment",
      "metadata": null,
      "name": "hooksUseGroupSubscriptionDataQuery",
      "selections": [{
        "alias": null,
        "args": v0 /*: any*/,
        "concreteType": "AppConfig",
        "kind": "LinkedField",
        "name": "appConfig",
        "plural": false,
        "selections": [v1 /*: any*/],
        "storageKey": "appConfig(filter:{\"entityId\":\"acquisition\"})"
      }],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [],
      "kind": "Operation",
      "name": "hooksUseGroupSubscriptionDataQuery",
      "selections": [{
        "alias": null,
        "args": v0 /*: any*/,
        "concreteType": "AppConfig",
        "kind": "LinkedField",
        "name": "appConfig",
        "plural": false,
        "selections": [v1 /*: any*/, {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        }],
        "storageKey": "appConfig(filter:{\"entityId\":\"acquisition\"})"
      }]
    },
    "params": {
      "cacheID": "f8a59a268fef536b2b8a27cbc8bf3147",
      "id": null,
      "metadata": {},
      "name": "hooksUseGroupSubscriptionDataQuery",
      "operationKind": "query",
      "text": "query hooksUseGroupSubscriptionDataQuery {\n  appConfig(filter: {entityId: \"acquisition\"}) {\n    json\n    id\n  }\n}\n"
    }
  };
}();
node.hash = "10b91bd845ddc4c70e045441fbd4454d";
export default node;